import { styled } from '@mui/material/styles';

export const LogoBlockStyled = styled('div')`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;
